import React, { useEffect } from 'react';
import PageLayout from '../_partials/PageLayout';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { fetchPopular } from '../../../actions/cartoondraw/assetsActions';
import AssetCard from "../_partials/AssetCard";
import { Spin } from "antd";

const Popular: React.FC = () =>  {
  const dispatch  = useAppDispatch();
  const loading   = useAppSelector(state => state.cartoondraw.assets.loading);
  const assets    = useAppSelector(state => state.cartoondraw.assets.entities);
  const assetIds  = useAppSelector(state => state.cartoondraw.assets.ids);

  useEffect(() => {
    dispatch(fetchPopular());
  }, []);

  const RenderAssets = () => {
    return (
      <>
        {assets ? assetIds.map(id => <AssetCard asset={assets[id]} key={assets[id].id} />) : null}
      </>
    )
  }

  return (
    <PageLayout className='v-assets'>
      {loading ? <Spin /> : <RenderAssets />}
    </PageLayout>
  );
}

export default Popular;
